import { MobileTitle } from "../components/Title"

export const Story = () => {
    return (
        <>
            {' '}
            <MobileTitle title='Story' />
            <div className='py-12 md:py-48 drop-shadow-md w-4/5 md:w-3/5 mx-auto text-center text-shadow-white text-pbnavy font-kiwi font-bold text-sub md:text-base '>
                <p>
                    <span className='text-pborange'>Ivoire</span>—a world covered almost entirely with water, and dotted
                    with islands of various sizes. In this world, humans, beast-people, magical beings, and all kinds of
                    life coexist.
                </p>{' '}
                <img
                    className='my-12 white-drop-shadow cursor-pointer mx-auto'
                    src={`${process.env.PUBLIC_URL}/images/ss/ss-story-1.webp`}
                    alt={`screen shot of game story`}
                />{' '}
                <p className='mt-8'>
                    <span className='text-pborange'>Marona</span> , a girl who can see Phantoms, works alongside her{' '}
                    <span className='text-pborange'>Phantom</span> partner Ash as a{' '}
                    <span className='text-pborange'>Chroma</span>, a type of contractor who travels to various islands
                    and solves people's problems, upon request.
                </p>{' '}
                <p className='mt-8'>
                    As Marona and Ash are returning home from a Chroma job as usual, disaster strikes. Their ship is
                    attacked by a group of{' '}
                    <span className='text-pborange'>vicious ghost ships known as the “Shipwreck Fleet.”</span> A
                    mysterious masked man steals Marona's powers, and to save her, Ash jumps into the horde of enemies
                    alone. Thus, Marona and Ash are <span className='text-pborange'>separated</span>.
                </p>{' '}
                <p className='mt-8'>
                    After escaping the Shipwreck Fleet and washing ashore on an isolated island, Marona encounters a
                    young Phantom girl named <span className='text-pborange'>Apricot</span>, who wants to{' '}
                    <span className='text-pborange'>reunite with her lost father</span> —the captain of the Argento
                    Pirate Crew who once defeated the Shipwreck Fleet. However, the crew is now on the verge of
                    disbanding after losing their captain. Apricot wants to revitalize the crew and search for her
                    father, and Marona agrees to help her.
                </p>{' '}
                <p className='mt-8'>
                    To travel this region of the sea, which is filled with pirate territories, they must become
                    <span className='text-pborange'> pirates</span> themselves and expand their own territory. Marona
                    and Apricot decide to work together to
                    <span className='text-pborange'> revitalize the Argento Pirate Crew</span> in order to reunite with
                    those who are dear to them.
                </p>{' '}
                <p className='mt-8'>
                    Set on the high seas, where pirates and ghost ships run rampant, this story about the{' '}
                    <span className='text-pborange'>bond </span>
                    between Phantoms and the girl who connects with them begins now!
                </p>
            </div>
        </>
    )
}
